import React from 'react';
import AwardsContent from '../function-components/AwardsContent';

function Awards() {
  return (
      <>
        <AwardsContent />
      </>
  )
}

export default Awards;